import React from "react";

import AddItemButton from 'components/Buttons/AddItemButton';
import FavoritesList from "../../../FavoritesList"
import TagsList from "components/Tags/TagsList"

const FormData = ({
    form,
    onInputChange,
    onItemRemove,
    onSubmit,
    onCancel,
    setActiveSection
}) => {
    const MAX_LENGTH = 60;

    const handleRemoveFavorite = (uid) => {
        onItemRemove('favorite', uid)
    }

    const handleRemoveTag = (uid) => {
        onItemRemove('tag', uid)
    }

    return (
        <div className="card container-height">
            <form id="groupsForm" className="d-flex flex-column h-100" onSubmit={onSubmit}>

                <div className="card-header form-card-header-paddings no-background no-border">
                    <div className="p-2">
                        <h3>{form.uid ? 'Edit Group' : 'New Group'}</h3>
                    </div>
                </div>

                <div className="card-body form-card-body-paddings overflow-auto">
                    <div className="flex-grow-1 overflow-auto">
                        <div className="mb-3">
                            <div className="d-flex justify-content-between">
                                <label htmlFor="groupName" className="form-label">Title</label>
                                <small className="text-muted">
                                    {form.title.length}/{MAX_LENGTH}
                                </small>
                            </div>
                            <input
                                type="text"
                                id="groupName"
                                name="title"
                                value={form.title}
                                onChange={onInputChange}
                                className="form-control"
                                maxLength={MAX_LENGTH}
                                required
                            />
                        </div>

                        <div className="mb-2">
                            <h5>Favorites</h5>

                            <FavoritesList 
                                items={form.favorites}
                                onDeleteHandler={handleRemoveFavorite}
                            />

                            <AddItemButton onClick={() => setActiveSection('favorites')} />
                        </div>

                        <div className="mb-2">
                            <h5>Tags</h5>

                            <TagsList 
                                items={form.tags}
                                onDeleteHandler={handleRemoveTag}
                            />
                            
                            <AddItemButton onClick={() => setActiveSection('tags')} />
                        </div>
                    </div>
                </div>

                <div className="card-footer form-card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button 
                            type="submit" 
                            className="btn btn-success"
                        >
                            {form.uid ? 'Save' : 'Add'}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FormData;